<template>
  <div class="personal_warp">
    <myHeader />
    <div class="personal_content">
      <div class="personal_title">
        <h3>个人中心</h3>
       <div>
         <button @click="goOrder" class="btn1">我的订单</button>
         <button @click="logOut">退出登录</button>
       </div>
      </div>
      <div class="personal_info">
        <div class="info_item">
          <div class="item">
            <label>hecoos账号</label>
            <input :value="userInfo.hecoos_account || '暂无'" type="text" disabled>
          </div>
          <div class="item">
            <label>昵称</label>
            <input :value="userInfo.rname || '暂无'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>姓名</label>
            <input :value="userInfo.name || '暂无'" type="text" disabled>
          </div>
          <div class="item">
            <label>邮箱</label>
            <input :value="userInfo.email || '暂无'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>手机号码</label>
            <input :value="userInfo.phone || '暂无'" type="text" disabled>
          </div>
          <div class="item">
            <label>所在城市</label>
            <input :value="userInfo.city || '暂无'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>公司名称</label>
            <input :value="userInfo.company || '暂无'" type="text" disabled>
          </div>
          <div class="item">
            <label>从业时间</label>
            <input :value="userInfo.work_duration || '暂无'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>职位</label>
            <input :value="userInfo.position || '暂无'" type="text" disabled>
          </div>
          <div class="item" v-if="userInfo.phone || userInfo.email">
            <label>密码</label>
            <button @click="jumpTo('/forget_password')">修改密码</button>
          </div>
        </div>
      </div>
      <div class="vip_time">
        <p class="vip">会员时间：</p>
        <p class="time" v-if="start_time">{{ userInfo.start_time }} ~ <br />{{ userInfo.stop_time }}</p>
<!--        <p class="time" v-if="start_time">{{start_time }} ~ <br />{{ stop_time }}</p>-->
        <p class="time" v-else>暂无</p>
        <button @click="jumpTo('/SoftwareSubscriptions')">
          续费
        </button>
      </div>
      <button v-if="!userInfo.is_trial && (userInfo.phone || userInfo.email)" class="get_vip" @click="showModal = true">获取一个月免费授权</button>
      <div v-else class="footer_text">
        <p style="margin-bottom: 10px;">邀请链接： <span v-text="inviteLink + userInfo.recode"></span><button @click="copyInviteLink">复制链接</button></p>
        <p  style="font-size: 14px;">请分享此链接，
          成功邀请一名好友注册hcoos会员后，您的会员账号将自动获得7天免费时长；邀请多名好友注册，可累计免费时长，最高60天（价值396元）</p>
        <table v-if="userInfo.invite_register.length > 0">
          <thead>
            <tr>
              <th>编号</th>
              <th>邀请人</th>
              <th>注册时间</th>
              <th>奖励时长</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userInfoItem, index) in userInfo.invite_register" :key="userInfoItem.id">
              <td>{{ index + 1 }}</td>
              <td>{{ userInfoItem.name }}</td>
              <td>{{ userInfoItem.register_time }}</td>
              <td>{{ userInfoItem.time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Dialog -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>完善个人信息</h3>
          <button class="close-btn" @click="showModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <p data-label="昵称："><input type="text" v-model="userInfo.rname"></p>
          <p data-label="姓名："><input type="text" v-model="userInfo.name"></p>
          <p data-label="邮箱："><input type="text" v-model="userInfo.email"></p>
          <p data-label="公司名称："><input type="text" v-model="userInfo.company"></p>
          <p data-label="所在城市："><input type="text" v-model="userInfo.city"></p>
          <p data-label="职位："><input type="text" v-model="userInfo.position"></p>
          <p data-label="从业时间：">
            <select v-model="userInfo.work_duration" name="" id="">
              <option value="1">1年</option>
              <option value="2">2年</option>
              <option value="3">3年</option>
              <option value="4">4年</option>
              <option value="5">5年</option>
              <option value="6">6年</option>
              <option value="7">7年</option>
              <option value="8">8年</option>
              <option value="9">9年</option>
              <option value="10">10年</option>
              <option value="11">10年以上</option>
            </select>
          </p>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="confirmAuthorization">确认授权</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myHeader from "@/components/mobile/myHeader.vue";
import store from "@/store";
import { Message } from "element-ui"
import { getFreeVip,getPaySuccess } from "@/api/api";
export default {
  name: 'mobile_personalCenter',
  components: { myHeader, },
  data() {
    return {
      userInfo: {
        account: "",
        nickname: "",
        name: "",
        email: "",
        phone: "",
        city: "",
        company: "",
        workTime: "",
        position: "",
        memberExpire: "",
        recode: '',
        is_trial: ''
      },
      showModal: false,
      inviteLink: '',
      start_time:'',
      stop_time:'',
    }
  },
  created() {
    // 动态生成邀请链接
    this.inviteLink = `${window.location.origin}/#/register?recode=`
    if(store.state.adminUserInfo &&store.state.adminUserInfo.id){
      this.getPaySuccess()
    }
  },
  beforeMount() {
    this.userInfo = store.state.adminUserInfo;
    this.userInfo.is_trial = Number(this.userInfo.is_trial)
  },
  methods: {
    getPaySuccess(){
      getPaySuccess().then(res => {
        if(res.code == 200){
          if(res.data){
            let {start_time , stop_time} = res.data
            this.start_time = start_time
            this.stop_time = stop_time
          }

        }
      });
    },
    jumpTo(url) {
      this.$router.push(url)
    },
    goOrder() {
      this.$router.push("/order");
    },
    // 登出
    logOut() {
      store.commit("clearAdminUserInfo");
      localStorage.clear();
      this.$router.push("/login");
    },
    // 复制链接
    copyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink + this.userInfo.recode)
        .then(() => {
          Message.success("链接已复制到剪贴板");
        })
        .catch(err => {
          Message.error("复制失败，请手动复制...");
        });
    },
    // 获取免费会员
    confirmAuthorization() {
      // console.log(this.userInfo);
      let postData = {
        name: this.userInfo.name,
        rname: this.userInfo.rname,
        email: this.userInfo.email,
        company: this.userInfo.company,
        city: this.userInfo.city,
        position: this.userInfo.position,
        work_duration: this.userInfo.work_duration,
      }
      // console.log(postData);

      getFreeVip(postData).then(res => {
        Message.success('获取成功，请重新登录。');
        setTimeout(() => {
          this.logOut()
        }, 1000)
      });

      this.showModal = false;
    },
  }
}
</script>
<style lang="scss" scoped>
.personal_warp {
  .personal_content {
    padding: 30px;
    margin: 0 auto;
    max-width: 500px;

    .personal_title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 24px;
      }

      button {
        border: none;
        padding: 10px 24px;
        background-color: #000;
        color: #fff;
        font-size: 14px;
        border-radius: 8px;
        &.btn1{
          background-color: #1684ED;
          margin-right: 12px;
        }
      }
    }

    .personal_info {
      margin-top: 30px;

      .info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 16px;

        .item {
          width: 100%;

          label {
            display: block;
            font-size: 14px;
            margin-bottom: 4px;
          }

          input {
            width: 100%;
            height: 34px;
            border: 1px solid #e4e6ef;
            border-radius: 4px;
            padding: 0 10px;
            background-color: #f9f9f9;
            font-size: 14px;
          }

          button {
            border: 1px solid #2a82e4;
            width: 100%;
            // padding: ;
            padding: 8px 24px;
            border-radius: 8px;
            background-color: #fff;
            color: #2a82e4;
          }
        }
      }
    }

    .vip_time {
      display: flex;
      justify-content: space-around;
      gap: 10px;
      margin: 24px 0 30px;

      p {
        font-size: 14px;
        // text-align:center;
        // padding: 8px 0;
      }

      .vip {
        width: 80px;
      }

      .time {
        width: 175px;
      }

      button {
        // width: 100%;
        width: 80px;
        height: 40px;
        border: none;
        background-color: #2a82e4;
        color: #fff;
        padding: 8px 12px;
        border-radius: 8px;
      }
    }

    .get_vip {
      width: 100%;
      display: block;
      margin: 0 auto;
      border: none;
      font-size: 14px;
      padding: 12px 24px;
      background-color: #000;
      color: #fff;
      border-radius: 20px;
      margin-top: 32px;
    }
  }

  .footer_text {
    text-align: center;
    font-size: 16px;

    span {
      color: #2a82e4;
    }

    button {
      border: none;
      font-size: 10px;
      padding: 6px 12px;
      border-radius: 13px;
      margin-left: 6px;
      background-color: #cccccc;
      color: #fff;
      cursor: pointer;
    }

    table {
      // width: 70%;
      border-collapse: collapse;
      margin-top: 20px;
      margin: 20px auto;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .header {
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #777;
      padding: 0;
      line-height: 1;
    }
  }

  .modal-body {
    padding: 20px 54px;

    p {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      &::before {
        content: attr(data-label);
        display: inline-block;
        width: 80px;
        text-align: justify;
        text-align-last: justify;
        padding-right: 10px;
      }

      input,
      select {
        // 同时为input和select设置相同样式
        flex: 1;
        height: 40px;
        border: 1px solid #e4e6ef;
        border-radius: 4px;
        padding: 0 10px;
        background-color: #f9f9f9;
        font-size: 14px;
        appearance: none; // 移除默认样式
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px;
      }

      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");


        option {
          padding: 8px;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    text-align: center;

    .confirm-btn {
      background-color: #2a82e4;
      color: white;
      border: none;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #1a6bc8;
      }
    }
  }
}
</style>
